import { axios, API } from "@/imports-files/common/common";
import { SendRequest } from "@/imports-files/pages/admins/logout";

export class ReviewEmailServices extends SendRequest
{
    // set the api for the data
    async createCustomEmail(params)
    {
        const url =  API.email_templates.CREATE_CUSTOM_EMAIL;
        try 
        {
            const result = await axios.post(url,
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }

    async updateEmailTemplate(params, template_id)
    {
        const url =  API.email_templates.UPDATE_EMAIL_TEMPLATE.replace('$template_id', template_id);
        try 
        {
            const result = await axios.put(url,
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }

    async updateSystemEmail(params, template_id)
    {
        const url =  API.email_templates.UPDATE_CUSTOM_TEMPLATE.replace('$template_id', template_id);
        try 
        {
            const result = await axios.put(url,
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }

    async getTagVariableList()
    {
        const url =  API.email_templates.GET_VARIABLES 
        try 
        {
            const result = await axios.get(url,
            {
                headers: this.customHeaderJSON()
            },
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }


    async getSystemEmailTemplate(params, template_id)
    {
        const url =  API.email_templates.GET_EMAIL_TEMPLATE.replace('$template_id', template_id); 
        try 
        {
            const result = await axios.get(url,
            {
                params: params,
                headers: this.customHeaderJSON()
            },
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }

    async getCustomEmailTemplate(params, template_id)
    {
        const url =  API.email_templates.GET_EMAIL_TEMPLATE.replace('$template_id', template_id); 
        try 
        {
            const result = await axios.get(url,
            {
                params: params,
                headers: this.customHeaderJSON()
            },
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }


    async resetEmailTemplate(params, template_id)
    {
        const url =  API.email_templates.RESET_EMAIL_TEMPLATE.replace('$template_id', template_id); 
        
        try 
        {
            const result = await axios.put(url,
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }
}